import { Avatar, AvatarGroup } from "@/components/domain/avatar"
import { formatDateShort } from "@/lib/format-date"

import type { ClientRow } from "./clients-data"

export function ClientCell({ row }: { row: ClientRow }): JSX.Element {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <Avatar name={row.name} identity={row.id} size="md" />
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <span className="truncate text-body font-medium text-text">{row.name}</span>
          {!row.isActive && (
            <span className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-surface-sunken px-2 py-0.5 text-caption font-medium text-text-2 ring-1 ring-inset ring-border">
              <span className="size-1.5 rounded-full bg-text-3" aria-hidden="true" />
              Inactive
            </span>
          )}
        </div>
        {row.notes && (
          <div className="mt-0.5 truncate text-caption text-text-3" title={row.notes}>
            {row.notes}
          </div>
        )}
      </div>
    </div>
  )
}

export function MembersCell({ row }: { row: ClientRow }): JSX.Element {
  if (row.members.length === 0) {
    return (
      <span className="inline-flex items-center gap-1.5 text-caption text-text-3">
        <span className="size-1.5 rounded-full bg-text-3" aria-hidden="true" />
        Nobody yet
      </span>
    )
  }
  return (
    <AvatarGroup
      size="md"
      max={3}
      people={row.members.map((mem) => ({ name: mem.name, identity: mem.userId }))}
    />
  )
}

export function ReviewsCell({ row }: { row: ClientRow }): JSX.Element {
  if (row.reviewCount === 0) {
    return <span className="text-body-sm text-text-3">No reviews yet</span>
  }
  return (
    <div className="flex items-baseline gap-2 text-body-sm">
      <span className="text-text">
        <span className="font-id tabular-nums font-semibold">{row.openReviewCount}</span>{" "}
        still open
      </span>
      <span className="text-text-3">·</span>
      <span className="text-text-3">
        <span className="font-id tabular-nums">{row.reviewCount}</span> total
      </span>
    </div>
  )
}

export function SinceCell({ row }: { row: ClientRow }): JSX.Element {
  return (
    <span className="font-id tabular-nums text-body-sm text-text-3">
      {formatDateShort(row.createdAt)}
    </span>
  )
}
